<div class="p-4 text-[#0f2744]">
  <div class="relative min-h-8 pb-1">
    <h2
      id="line-values-dialog-title"
      class="m-0 pr-12 font-[Lato,Helvetica,Arial,sans-serif] text-xl font-normal text-wrap"
    >
      {{ chartTitle$() }}
    </h2>

    <button
      mat-icon-button
      type="button"
      class="absolute top-0 right-0 bottom-0 my-auto -translate-y-1 opacity-60 transition-opacity duration-200 hover:opacity-80 focus-visible:ring-2 focus-visible:ring-blue-700 focus-visible:ring-offset-1"
      aria-label="Close dialog"
      (click)="dialogRef.close()"
    >
      <mat-icon aria-hidden="true">close</mat-icon>
    </button>
  </div>
  <figure class="m-0 flex rounded-lg p-4 text-2xl font-normal">
    <div class="h-full min-h-95 w-full pt-3">
      <p id="line-values-chart-desc" class="sr-only">
        {{ chartDescription$() }}
      </p>
      <canvas
        baseChart
        role="img"
        [attr.aria-label]="'Line chart: ' + chartTitle$()"
        aria-describedby="line-values-chart-desc"
        [type]="chartService$.lineChartType"
        [data]="chartService$.lineChartData$()"
        [options]="chartService$.lineChartOptions"
        [plugins]="chartService$.lineChartPlugins"
        (chartClick)="chartService$.chartClicked($event)"
      ></canvas>

      <figcaption class="sr-only">
        <h3 id="line-values-data-table-title">
          {{ chartTitle$() }} data table
        </h3>
        <table aria-labelledby="line-values-data-table-title">
          <caption>
            {{
              chartTitle$()
            }}
            data points
          </caption>
          <thead>
            <tr>
              <th scope="col">Label</th>
              <th scope="col">{{ chartValueHeader$() }}</th>
            </tr>
          </thead>
          <tbody>
            @for (row of accessibleChartRows$(); track $index) {
              <tr>
                <th scope="row">{{ row.label }}</th>
                <td>{{ row.value }}</td>
              </tr>
            } @empty {
              <tr>
                <td colspan="2">No chart data available</td>
              </tr>
            }
          </tbody>
        </table>
      </figcaption>
    </div>
  </figure>
</div>
